export enum PostsSortOrder {
  NEWEST = '',
  OLDEST = 'oldest',
}

export enum PostsType {
  JOURNALS = 'journals',
  STATUSES = 'statuses',
  POLLS = 'polls',
  DRAFTS = 'drafts',
}

export enum JournalFilterType {
  FEATURED = 'featured',
  ALL = '',
}
